//@ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { getApiData } from "../helpers/AxiosInstance";

const useGetHook = ({ queryKey, url, params, enabled = true }) => {
  const { isPending, error, data, refetch } = useQuery({
    queryKey,
    queryFn: async () => {
      const response = await getApiData(url, params);
      return response.data;
    },
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: enabled,
  });

  return { isPending, error, data, refetch, enabled };
};

export default useGetHook;
